<template>
  <div class="question-image">
    <img class="image-src" :src="asset" alt="" />
  </div>
</template>

<script>

export default {
  props: {
    asset: {
      type: String,
      required: true
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    urlFor(asset) {
      return 'https://img.icons8.com/bubbles/50/undefined/checklist.png'
    }
  }
}
</script>

<style lang="sass">
.question-image
  display: flex
  justify-content: center
  max-height: 250px
  overflow: hidden

.image-src
  object-fit: contain
  padding: 0 1rem
  width: 100%
</style>

